import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question: "What does a mobile app development company do?",
    answer: ` <p>In the mobile app development sector, a company provides end-to-end organization, conceptualization, design, optimization, and maintenance of your mobile app project. These professionals have the capability to transform a basic concept into a fully functional product, poised to become your potential revenue-generating success.</p>`,
  },
  {
    question: " How much does it cost to develop a mobile phone app?",
    answer: `<p>The development cost of an app can exhibit significant variations based on factors such as size and complexity. Some apps cost as little as $5,000 to develop, while others cost over $1 million! It's evident that the complexity and scalability of features directly influence the development expenses, with more complex apps naturally incurring higher costs.</p>`,
  },
  {
    question: "How can I develop an app?",
    answer: ` <p>Discover our straightforward guide to kickstart your journey in creating a new mobile app:</p>   
        <ul>
        <li>Form a team</li>
        <li>Conduct research on competitors</li>
        <li>Define essential features</li>
        <li>Develop mockups</li>
        <li>Strategize app security</li>
        <li>Commence coding</li>
        <li>Conduct thorough testing</li>
        <li>Collect and apply feedback</li>
    </ul>`,
  },
  {
    question:
      "Why should I choose TekRevol for mobile app development in Bahrain?",
    answer: ` <p>TekRevol is a leading mobile app development company in Bahrain, empowering businesses with state-of-the-art technology and digital solutions. Our comprehensive development services, combined with strategic planning and fail-proof digital strategies, enable our clients to become future-ready and scale with sustainability.</p>`,
  },
  {
    question:
      "Does TekRevol offer post-launch support and app maintenance services?",
    answer: ` <p>Yes. TekRevol provides unparalleled post-launch support to our clients to promptly address the concerns of the end users. We strongly believe every happy customer is an asset to TekRevol and take full measures to ensure our clients get the desired results.</p>`,
  },
  {
    question: "I want to build an app, where should I start?",
    answer: `<p>If you have an app idea that you think has the potential to top the charts on the application stores, we are here to help! Book your free consultation session with our consultants and get a free project roadmap and cost estimate for your app business today.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
